import React from 'react';
import './carrossel.component.scss';
import OwlCarousel from "react-owl-carousel";
import CarrosselModel from '../../models/carrossel.model';

export type CarrosselComponentProps = {
  carrossel?: CarrosselModel;
  ID?: string;
  isScroll?: boolean;
}

function CarrosselComponent(props: CarrosselComponentProps) {

  const options = {
    loop: props.carrossel?.loop,
    margin: 10,
    items: props.carrossel?.qtd_por_slide,
    autoplay: props.carrossel?.autoplay,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 3
      },
      1000: {
        items: props.carrossel?.qtd_por_slide
      }
    }
  };

  const css = `
    #${'component-' + props.ID} h2 {
      color: ${props.carrossel?.cor_do_titulo}
    }
    #${'component-' + props.ID} .txt {
      color: ${props.carrossel?.cor_do_texto}
    }
    #${'component-' + props.ID} .owl-theme .owl-dots .owl-dot.active span, 
    #${'component-' + props.ID} .owl-theme .owl-dots .owl-dot:hover span {
      background: ${props.carrossel?.cor_do_bullets};
      opacity: 1;
    }
    #${'component-' + props.ID} .owl-theme .owl-dots .owl-dot span {
      background: ${props.carrossel?.cor_do_bullets};
      opacity: .5;
    }
    #${'component-' + props.ID} section.carrossel.thumbs .item {
      border: solid 1px ${props.carrossel?.cor_da_borda};
    }
  `;

  return (
    <>
      <style>{css}</style>
      <section
        id={props.isScroll ? props.carrossel?.id : 'component-' + props.ID}
        style={props.carrossel?.bg ? { backgroundColor: props.carrossel?.bg } : { backgroundColor: '#fff' }}
        className={"carrossel full-" + props.carrossel?.full + ' ' + (props.carrossel && (props.carrossel.qtd_por_slide > 1 && 'thumbs'))}>
        <div className="container">
          {
            props.carrossel?.titulo &&
            <h2>{props.carrossel?.titulo}</h2>
          }
          {
            props.carrossel?.descricao &&
            <div className='txt'>{props.carrossel?.descricao}</div>
          }
          <OwlCarousel className="owl-theme" {...options}>
            {
              props.carrossel?.itens.map(item => (
                <React.Fragment key={item.id}>
                  <div style={{
                    borderRadius: props.carrossel?.borda_arredondada ? '10px' : "0"
                  }} className="item">
                    <img
                      src={item.imagem}
                      alt={item.titulo}
                      className={item.imagem_mobile && 'desktop'}
                    />
                    {
                      item.imagem_mobile &&
                      <img
                        src={item.imagem_mobile}
                        alt={item.titulo}
                        className='mobile'
                      />
                    }
                    {
                      (item.titulo && item.descricao) &&
                      <div
                        style={{
                          color: props.carrossel?.cor_do_texto_legenda ? props.carrossel?.cor_do_texto_legenda : "#000",
                          backgroundColor: props.carrossel?.cor_de_fundo_legenda ? props.carrossel?.cor_de_fundo_legenda : "#f1f1f1",
                        }}
                        className="box-txt">
                        <h3>{item.titulo}</h3>
                        <div>
                          {item.descricao}
                        </div>
                      </div>
                    }
                  </div>
                </React.Fragment>
              ))
            }
          </OwlCarousel>
        </div>
      </section>
    </>
  );
}

export default CarrosselComponent;
